import api from 'api/api';
import downloadReceipt from 'utils/downloadReceipt';
import { IMobileMoneyChargeResponse, IWalletBenResponse } from './ManualEntry.model';

export const lookupBen = (networkCode: string, phoneNumber: string, transferType: 'A2W') =>
  api.get<IWalletBenResponse>(
    `transfer/mobilemoneylookup?network=${networkCode}&phoneNumber=${phoneNumber}&transferType=${transferType}`,
  );

export const getReceipt = (transactionID: number) =>
  api.get(`/transaction/receipt?trnxID=${transactionID}`).then(downloadReceipt);

export const getTransactionFee = (amount: number, phoneNumber: string) =>
  api.get<IMobileMoneyChargeResponse>(
    `transfer/momocharge?amount=${amount}&phoneNumber=${phoneNumber}`,
    {},
    false,
    false,
  );
